module.exports = __webpack_public_path__ + "static/media/calendar-new.795113c4.svg";